import React from 'react';
import PropTypes from 'prop-types';

import FormButton from './index';
import './styles.scss';

const submit = props => (
  <FormButton
    text={props.text}
    onClick={props.onClick}
    className="ant-btn-primary"
    disabled={props.disabled}
  />
);

submit.defaultProps = {
  disabled: false,
};
submit.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default submit;
